import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment, API } from '@core/envs';
import { IResponseModel, TermsModel } from '@core/interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LegalService {
  constructor(private http: HttpClient) {}


  getLegalLanguageData(countryCode: string): Observable<IResponseModel<TermsModel>> {
    let url: string = environment.getRoute(API.transformation, true);
    url = url.concat('/climes');
    url = url.concat('/legallanguagedata');
    url = url.concat('/' + countryCode);
    return this.http.get<IResponseModel<TermsModel>>(url);
  }
}
